import React, { FC, SyntheticEvent } from "react";
import { COLOR_PRIMARY_MAIN } from "shared/theme/colors";
import { useTagDetails } from "../../context";
import { TagDetailsTabs } from "../../context/types";
import { StyledTab, StyledTabs } from "./styled";
import useRolePermission from "entities/auth/hooks/useRolePermission";

const Tabs: FC = () => {
  const { selectedTab, setSelectedTab } = useTagDetails();
  const { allowed: hasReadAccess } = useRolePermission("tags:read");
  const { allowed: hasReadTranslationsAccess } = useRolePermission("tags:translations:read");

  const shouldRenderGeneralTab = hasReadAccess;
  const shouldRenderTranslationsTab = hasReadAccess || hasReadTranslationsAccess;

  const handleTabChange = (_: SyntheticEvent, newTab: TagDetailsTabs) => {
    setSelectedTab(newTab);
  };

  return (
    <StyledTabs
      value={selectedTab}
      onChange={handleTabChange}
      TabIndicatorProps={{
        style: {
          backgroundColor: COLOR_PRIMARY_MAIN,
          height: 2,
        },
      }}
    >
      {shouldRenderGeneralTab && (
        <StyledTab
          id="tag-tab-general"
          aria-controls="tag-tabpanel-general"
          value={TagDetailsTabs.General}
          disableRipple
          label="General"
        />
      )}
      {shouldRenderTranslationsTab && (
        <StyledTab
          id="tag-tab-translations"
          aria-controls="tag-tabpanel-translations"
          value={TagDetailsTabs.Translations}
          disableRipple
          label="Translations"
        />
      )}
    </StyledTabs>
  );
};

export default Tabs;
